import Report from '../../../../common/types/api/report'
import { PDF } from '../../../../common/types/api/pdf'
import { PropsFilesPdfWrapper } from './types'
import { arrayHasContent } from '../../../../common/helper/arrayHasContent'

export function getPdf(report: Report): PropsFilesPdfWrapper {
    if (arrayHasContent<PDF>(report.files?.pdf)) {
        return {
            page: report.page,
            files: report.files?.pdf
        }
    }

    return {
        page: report.page,
        files: []
    }
}

export function pdfGetFirstOrCreate(files: PDF[] = []): PDF {
    if (Array.isArray(files) && files.length > 0) {
        return files[0]
    }
    return {
        fileName: 'file',
        layout: [],
        size: ''
    }
}
